export default __webpack_public_path__ + "static/media/envelope-white.c1f06fb2.svg";